import { useContext } from 'react';
import { AmpContext } from '@immediate_media/component-config';
const useAmp = () => {
  const {
    useAmp: externalUseAmp
  } = useContext(AmpContext);
  return externalUseAmp ? externalUseAmp() : false;
};
export default useAmp;